import { render } from "./CollectGroups.vue?vue&type=template&id=bfb86600"
import script from "./CollectGroups.vue?vue&type=script&lang=js"
export * from "./CollectGroups.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__